import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Modal } from 'antd';
import { Grid, Card } from '@material-ui/core';
import MainContainer from '../../../components/MainContainer';
import SpaOfferList from '../../../components/AdminSpaOffer/List';
import UpdateSpaOfferModal from '../../../components/AdminSpaOffer/Update/UpdateSpaOffer';
import SearchMenuItemModal from '../../../components/AdminSpaOffer/SearchMenuItem/SpaOfferSearchItem';

@inject(
    'loginStore',
    'spaOfferStore'
)
@observer
class SpaOfferPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        this.props.loginStore.authenticateAdmin().then(response => {
          if (!response) {
            this.props.history.push('/admin/login');
          }
        });
        
        this.props.spaOfferStore.init();
    }

    componentWillUnmount() {
        this.props.spaOfferStore.setShowUpdateSpaOfferModal(false);
    }

    handleCancelUpdateSpaOfferModal = () => {
        this.props.spaOfferStore.setShowUpdateSpaOfferModal(false);
    }

    handleCancelSearchMenuIteModal = () => {
        this.props.spaOfferStore.setShowSearchMenuItemModal(false);
    }

    render() {
        const {
            showUpdateSpaOfferModal,
            showSearchMenuItemModal,
            manageSpaOfferTitle
        } = this.props.spaOfferStore;

        return (
            <MainContainer title="Devarana Wellness Offer" menukey='spaoffers'>
                <Modal
                    title={manageSpaOfferTitle}
                    visible={showUpdateSpaOfferModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelUpdateSpaOfferModal}
                    zIndex={1000}
                >
                    <UpdateSpaOfferModal />
                </Modal>

                <Modal
                    title="Search Devarana Wellness"
                    visible={showSearchMenuItemModal}
                    width={800}
                    footer={null}
                    onCancel={this.handleCancelSearchMenuIteModal}
                    zIndex={2000}
                >
                    <SearchMenuItemModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: "auto" }}>
                            <SpaOfferList />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default SpaOfferPage